import React from 'react';

const Timeline = () => {
  const events = [
    { date: 'April 20', title: 'LLR Token Launched' },
    { date: 'April 21', title: 'Wallet Build Started' },
    { date: 'April 22', title: 'Validator Staking Live' },
    { date: 'April 23', title: 'Merchant QR System Ready' },
    { date: 'April 24', title: 'Countdown Site Goes Live' },
  ];

  return (
    <div className="mt-10">
      <h2 className="text-3xl font-bold text-center mb-8">Project Timeline</h2>
      <ol className="relative border-l border-gray-700 ml-4">
        {events.map((event, idx) => (
          <li key={idx} className="mb-10 ml-6">
            <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full -left-3 ring-4 ring-white"></span>
            <h3 className="text-lg font-semibold">{event.title}</h3>
            <time className="block mb-2 text-sm font-normal text-gray-400">{event.date}</time>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Timeline;
